import { useUserStore } from '@/stores/user';

/**
 * 同步获取当前 userId。
 *
 * Zustand persist rehydrate 是异步的，beforeAppRender 阶段 store 可能还未恢复。
 * 此函数优先从 store 读取，降级从 localStorage 直接解析 persist 数据。
 */

const PERSIST_KEY = 'wegic-builder-user-store';

export function getUserId(): string | null {
  // 优先从 store 读（rehydrate 完成后可用）
  const userId = useUserStore.getState().userInfo?.userId;
  if (userId) {
  return userId;
}

  // 降级：直接从 localStorage 解析 persist 数据
  try {
    const raw = localStorage.getItem(PERSIST_KEY);
    if (raw) {
      const parsed = JSON.parse(raw);
      return parsed?.state?.userInfo?.userId || null;
    }
  } catch {}

  return null;
}
